export const FETCH_PATIENTORDER_INIT_ACTION = "FETCH_PATIENTORDER_INIT_ACTION";
export const FETCH_PATIENTORDER_SUCCESS_ACTION =
  FETCH_PATIENTORDER_INIT_ACTION + "_SUCCESS";
export const FETCH_PATIENTORDER_FAIL_ACTION =
  FETCH_PATIENTORDER_INIT_ACTION + "_ERROR";

export function PatientOrder(value) {
  return {
    type: FETCH_PATIENTORDER_INIT_ACTION,
    value: value
  };
}

export function PatientsOrderSlectedPage(value) {
  return {
    type: FETCH_PATIENTORDER_INIT_ACTION,
    value: value
  };
}